import React, {useEffect, useState, useCallback, useContext} from 'react'
import {getErrorMessageForNonStandardAndStandardResponse} from '../../util/NetworkErrorUtil';
import {getAllSupplierInventoryCorrections} from '../../components/inventory-correction/requests/inventory-correction-requests';
import Busy from '../../components/Busy';
import moment from 'moment';
import {DateFormats} from '../../components/constants/securspace-constants';
import {
  InventoryCorrectionReasonLabel,
  InventoryCorrectionReasons,
  InventoryCorrectionStatus
} from "../../components/constants/inventory-correction-constants";
import {AppContext} from '../../context/app-context';
import InventoryCorrections from "./InventoryCorrections";
import { ObservableVariables } from '../../components/constants/observable-constants';
import {useSnackbar} from "../../context/snackbar-context";

const sortByOptions = [
  {value: "none", label: "None"},
  {value: "orderNumber", label: "Booking Number"},
  {value: "buyerName", label: "Buyer Name"},
  {value: "dateOfSubmission", label: "Date of submission"}
];

const defaultSearchFilter = {searchFilter: '', sortBy: 'none', sortDir: 'desc'};

const SupplierInventoryCorrections = ({account}) => {
  const appContext = useContext(AppContext);
  const { snackbarShowMessage } = useSnackbar();

  const [inventoryCorrections, setInventoryCorrections] = useState([]);
  const [rawCorrections, setRawCorrections] = useState([]);

  const fetchInventoryCorrections = useCallback(() => {
    Busy.set(true);
    getAllSupplierInventoryCorrections(account.id, {status: InventoryCorrectionStatus.PENDING})
      .then((response) => {
        const formattedCorrection = response.body?.map((item) => {

          return {
            ...item,
            dateOfSubmission: moment(item?.creationDate).format(DateFormats.DAY),
            buyerName: item?.locationInventoryActivityGetVO?.buyerName,
            orderNumber: item?.locationInventoryActivityGetVO?.orderNumber,
            reason: InventoryCorrectionReasons[item?.reason] ? InventoryCorrectionReasonLabel[item.reason] : 'N/A',
          }
        });
        setRawCorrections(response.body);
        setInventoryCorrections(formattedCorrection);
        ObservableVariables.PENDING_INVENTORY_CORRECTIONS_COUNT.refreshData(appContext);
      })
      .catch((error) => {
        snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error');
      }).finally(() => {
      Busy.set(false);
    });
  }, [account, snackbarShowMessage, appContext]);

  useEffect(() => {
    if (account.id) {
      fetchInventoryCorrections();
    }
  }, [account, fetchInventoryCorrections]);

  return (
    <InventoryCorrections
      fetchInventoryCorrections={fetchInventoryCorrections}
      inventoryCorrections={inventoryCorrections}
      rawCorrections={rawCorrections}
      sortByOptions={sortByOptions}
      account={account}
      defaultSearchFilter = {defaultSearchFilter}
    />
  )
}

export default SupplierInventoryCorrections;
